export default "__VITE_ASSET__DIOFQCYM__"